// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"d21f2822ffffc677","931":"bbe42747d5324865"}[chunkId] + ".css";
};